// extracted by mini-css-extract-plugin
export default {"root":"BreadcrumbsNav_root__x3TNI","backButton":"BreadcrumbsNav_backButton__fNdbz"};